var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-box active"},[_c('span',{staticClass:"alert-text"},[_vm._v("\n    "+_vm._s(_vm.messageProp)+"\n    "),_c('span',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("x")])])])}
var staticRenderFns = []

export { render, staticRenderFns }